var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayOverTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_19224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 78.001C0 121.079 34.9208 156.002 78.0012 156.002C121.082 156.002 156.002 121.081 156.002 78.001",
    fill: "#FFD31F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 78.001C0 121.079 34.9208 156.002 78.0012 156.002V78.001H0Z",
    fill: "#FFEFB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.781 20.9646L78.2601 85.139L52.3753 59.5756L56.6991 55.1987L78.2439 76.4776L138.441 16.6016L142.779 20.9646H142.781Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.566 78.001C126.566 104.824 104.822 126.566 78.0011 126.566C51.1799 126.566 29.4363 104.822 29.4363 78.001H14.3401C14.3401 113.16 42.8399 141.66 77.9988 141.66C113.158 141.66 141.658 113.16 141.658 78.001H126.564H126.566Z",
    fill: "#0577FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0012 141.66C113.16 141.66 141.66 113.16 141.66 78.001H126.566C126.566 104.824 104.822 126.566 78.0012 126.566",
    fill: "#FFB257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.66 78.001C141.66 42.8421 113.16 14.3423 78.0012 14.3423V29.4361C104.825 29.4361 126.566 51.1798 126.566 78.001",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.487 32.4722L111.784 43.1174C113.259 44.5463 114.644 46.0677 115.93 47.6724L126.679 36.9809C125.354 35.4109 123.956 33.9057 122.49 32.4722H122.487Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0012 14.3403C42.8423 14.3403 14.3424 42.8402 14.3424 77.9991H29.4363C29.4363 51.1756 51.1799 29.4342 78.0012 29.4342",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77 21.5148V0L98.7552 21.05L98.7136 21.0916L77.77 21.5148Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.77 42.1831V21.0914L98.7552 21.0498L98.7136 21.0914L77.77 42.1831Z",
    fill: "#091F83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_19224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayOverTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PayOverTime.53dddee12fd3ab900a044f3b6e7292f9.svg";